exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".shadow-st[data-v-562f4ea6]{background-color:#040404;position:absolute;top:0;left:0;width:100%;height:100%;z-index:2;opacity:.56}.inner-text[data-v-562f4ea6]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end;margin:10px;color:#fff;font-weight:500;font-size:15px}", ""]);

// exports
